import { render, staticRenderFns } from "./PageItemDetail.vue?vue&type=template&id=2a0d3bae&scoped=true"
import script from "./PageItemDetail.vue?vue&type=script&lang=ts"
export * from "./PageItemDetail.vue?vue&type=script&lang=ts"
import style0 from "./PageItemDetail.vue?vue&type=style&index=0&id=2a0d3bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d3bae",
  null
  
)

export default component.exports